export const SAVE_DATA_RECORD_SELECTED = 'SAVE_DATA_RECORD_SELECTED';
export const saveDataRecordSelected  = (key, values) => ({
  type: SAVE_DATA_RECORD_SELECTED,
  payload: { [key]: values}
});



// WEBPACK FOOTER //
// ./src/actions/recordSelectedActions.js